import Vue from 'vue'
import FormFocusableMixin from 'mixins/FormFocusableMixin'
import HandleRequestMixin from 'mixins/HandleRequestMixin'
import ValidationService from 'services/ValidationService'
import { importComponents } from '~/helpers'

function setValue(object, path, value) {
    let settablePath = path

    if (path.indexOf('.') !== -1) {
        const parts = path.split('.')
        settablePath = parts.splice(-1, 1)
        parts.forEach((part) => {
            if (!object[part]) {
                Vue.set(object, part, {})
            }

            object = object[part]
        })
    }

    Vue.set(object, settablePath, value)
}

export default {
    mixins: [FormFocusableMixin, HandleRequestMixin],

    components: {
        ...importComponents(require.context('components/form-elements')),
        ...importComponents(require.context('components/form-inputs')),
        ...importComponents(require.context('components/form-fields')),
        ...importComponents(require.context('components/form-fragments')),
    },

    data() {
        return {
            data: {},
        }
    },

    methods: {
        change({ path, value }) {
            this.emitEvent({ name: 'local:beforeChange', payload: { path, value } })
            this.emitEvent({ name: `local:beforeChange:${path}`, payload: { path, value } })
            this.emitEvent({ name: `local:beforeChange:${path.replace(/\d+/g, '*')}`, payload: { path, value } })

            if (ValidationService.get(path)) {
                ValidationService.clearFieldValidation(path)
            }

            setValue(this.data, path, value)

            this.emitEvent({ name: 'local:afterChange', payload: { path, value } })
            this.emitEvent({ name: `local:afterChange:${path}`, payload: { path, value } })
            this.emitEvent({ name: `local:afterChange:${path.replace(/\d+/g, '*')}`, payload: { path, value } })
        },

        prefill({ path, value }) {
            setValue(this.prefills, path, value)
        },

        prefillData(data) {
            for (let [path, value] of Object.entries(data)) {
                setValue(this.data, path, value)
            }
        },

        emitSent(payload) {
            return this.emitEvent({ name: 'sent', payload })
        },
    },
}
